<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div class="immersion01">
    <NavBar />

    <div v-if="isWrongBrowser()">
      <h1>Bienvenue !</h1>
      <p>
        Oups, il semblerait que tu utilises un navigateur sur lequel notre site a du mal à fonctionner...
        <br />Pour jouer à ExploRêve, et plus généralement pour soutenir un développement libre d'internet, <br />nous
        t'invitons fortement à télécharger et utiliser Firefox, en allant
        <a href="https://www.mozilla.org/fr/firefox/new/">ici</a>
      </p>
      <img src="https://cdn.exploreve.fr/content/personnages/leon.svg" alt="leon" />
      <img src="https://cdn.exploreve.fr/content/personnages/daria.svg" alt="daria" />
      <img src="https://cdn.exploreve.fr/content/personnages/erwin.svg" alt="erwin" />
    </div>
    <div v-else>
      <div v-if="isMobile()">
        <h1>Bienvenue !</h1>
        <p>
          Pour entrer dans la 1ère immersion, un ordinateur est nécessaire. En attendant, n'hésite pas nous rejoindre
          sur les réseaux sociaux, à parcourir le blog et à lire la page à propos pour en savoir plus sur le projet !
        </p>
        <img src="https://cdn.exploreve.fr/content/personnages/daria.svg" alt="daria" />
      </div>
      <div v-else-if="!ageDeffined">
        <AgeSelectionScreen @ageChoosed="fetchNeddHelp" />
      </div>
      <router-view v-else @audio="setAudio" />
    </div>

    <audio id="music01" class="audio_music" loop>
      <source src="https://cdn.exploreve.fr/content/music/musique_1.mp3" />
    </audio>
    <audio id="music02" class="audio_music" loop>
      <source src="https://cdn.exploreve.fr/content/music/musique_2.mp3" />
    </audio>
    <audio id="music03" class="audio_music" loop>
      <source src="https://cdn.exploreve.fr/content/music/musique_3.mp3" />
    </audio>
    <audio id="music04" class="audio_music" loop>
      <source src="https://cdn.exploreve.fr/content/music/musique_4.mp3" />
    </audio>
    <audio id="music05" class="audio_music" loop>
      <source src="https://cdn.exploreve.fr/content/music/musique_5.mp3" />
    </audio>
    <SoundVolumeButton class="volume-button" @audio="setAudio" />
    <ButtonHelpKids v-if="needHelp" />
  </div>
</template>

<script>
// @ is an alias to /src
import NavBar from "@/components/NavBar.vue";
import SoundVolumeButton from "@/components/SoundVolumeButton.vue";
import ButtonHelpKids from "@/components/ButtonHelpKids.vue";
import AgeSelectionScreen from "@/components/AgeSelectionScreen.vue";

export default {
  name: "immersion01",
  components: {
    AgeSelectionScreen,
    NavBar,
    SoundVolumeButton,
    ButtonHelpKids
  },
  created: function () {
    this.needHelp = localStorage.getItem("age") == "moins11Ans";
    if (this.$route.path == "/immersion01") {
      this.ageDeffined = false;
    } else {
      this.ageDeffined = localStorage.getItem("age") != undefined && localStorage.getItem("age") != null;
    }
  },
  data: function () {
    return {
      ageDeffined: false,
      needHelp: false,
      volume: 1,
      muted: false,
      musics: [
        "https://cdn.exploreve.fr/content/music/musique_1.mp3",
        "https://cdn.exploreve.fr/content/music/musique_2.mp3",
        "https://cdn.exploreve.fr/content/music/musique_3.mp3",
        "https://cdn.exploreve.fr/content/music/musique_4.mp3",
        "https://cdn.exploreve.fr/content/music/musique_5.mp3"
      ],
      currentMusic: ""
    };
  },
  mounted: function () {
    this.currentMusic = document.getElementById("music04");
  },
  methods: {
    fetchNeddHelp(selected) {
      if (selected) {
        this.needHelp = selected == "moins11Ans";
      } else {
        this.needHelp = localStorage.getItem("age") == "moins11Ans";
      }

      this.ageDeffined = localStorage.getItem("age") != undefined && localStorage.getItem("age") != null;
    },
    isMobile: function () {
      return document.documentElement.clientWidth < 760;
    },
    isWrongBrowser: function () {
      const ua = window.navigator.userAgent;
      return ua.indexOf("Edge") !== -1 || ua.indexOf("Edg") !== -1 || ua.indexOf("MSIE") !== -1;
    },

    setAudio: function (music) {
      switch (music.action) {
        case "play":
          this.currentMusic.pause();
          switch (music.id) {
            case 1:
              document.getElementById("music01").play();
              this.currentMusic = document.getElementById("music01");
              break;
            case 2:
              document.getElementById("music02").play();
              this.currentMusic = document.getElementById("music02");
              break;
            case 3:
              document.getElementById("music03").play();
              this.currentMusic = document.getElementById("music03");
              break;
            case 4:
              document.getElementById("music04").play();
              this.currentMusic = document.getElementById("music04");
              break;
            case 5:
              document.getElementById("music05").play();
              this.currentMusic = document.getElementById("music05");
              break;
          }
          this.currentMusic.muted = this.muted;
          this.currentMusic.volume = this.volume;
          break;
        case "pause":
          this.currentMusic.pause();
          break;
        case "mute":
          this.muted = music.muted;
          this.currentMusic.muted = music.muted;
          break;
        case "volume":
          this.volume = music.volume;
          this.currentMusic.volume = music.volume;
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.immersion01 {
  p {
    padding: 20px;
  }
  img {
    height: 300px;
    margin: auto;
    margin-bottom: 30px;
  }
  .volume-button {
    position: fixed;
    bottom: 140px;
    right: 0;
    margin: 30px;
  }
}
</style>
